var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightTool"},[_c('div',{staticClass:"reminder"},[_c('div'),(_vm.name!='查看计划')?_c('div',{staticClass:"explain"},[_vm._v(" 请先在地图中点选圈出片区位置，"),_c('span',{staticStyle:{"color":"#ff0e52","font-size":"18px"}},[_vm._v("双击结束")]),_vm._v("，可拖动圆点进行微调 ")]):_vm._e(),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }